/**
 * Check if a value is not null or undefined - useful to filter from an array
 * @param value - The value to check
 * @returns Whether the value is not null or undefined
 */
const compact = (value) => value != null;

export { compact };
//# sourceMappingURL=compact.js.map
